var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaCountryCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4295_19716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0009C24 11.4704 23.9651 10.9481 23.8984 10.4357H10.4347C7.98306 7.98426 3.51452 3.516 3.5147 3.51562C-1.17157 8.2019 -1.17157 15.7999 3.5147 20.4862L10.4348 13.5662H23.8984C23.9651 13.0538 24 12.5314 24 12.0009Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9966 12.2773C23.996 12.3005 23.9955 12.3238 23.9949 12.3469C23.9954 12.3237 23.996 12.3005 23.9966 12.2773Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9848 12.6055C23.9838 12.6284 23.9822 12.6512 23.981 12.6741C23.9822 12.6513 23.9837 12.6284 23.9848 12.6055Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9689 12.8672C23.9665 12.9009 23.9641 12.9346 23.9614 12.9682C23.9641 12.9346 23.9664 12.9009 23.9689 12.8672Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9287 10.6953C23.9331 10.7354 23.9375 10.7755 23.9415 10.8157C23.9375 10.7755 23.9331 10.7354 23.9287 10.6953Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.981 11.332C23.9822 11.3549 23.9838 11.3777 23.9848 11.4007C23.9837 11.3777 23.9822 11.3549 23.981 11.332Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9949 11.6602C23.9955 11.6833 23.996 11.7066 23.9966 11.7297C23.996 11.7065 23.9955 11.6833 23.9949 11.6602Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9614 11.0391C23.9641 11.0727 23.9665 11.1064 23.9689 11.1401C23.9664 11.1064 23.9641 11.0727 23.9614 11.0391Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4347C23.9038 10.4758 23.9086 10.5172 23.9135 10.5584C23.2013 4.6108 18.1395 0 12 0C8.68626 0 5.68622 1.3432 3.51465 3.51487L10.4345 10.4348H23.8984V10.4347Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 13.5651H10.4345L3.51465 20.485C5.68622 22.6566 8.68626 23.9998 12 23.9998C18.1395 23.9998 23.2014 19.389 23.9135 13.4414C23.9086 13.4826 23.9037 13.524 23.8984 13.5651Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9415 13.1875C23.9375 13.2277 23.9331 13.2678 23.9287 13.3079C23.9331 13.2678 23.9376 13.2278 23.9415 13.1875Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9136 10.5586C23.919 10.6031 23.9241 10.6477 23.9289 10.6923C23.924 10.6477 23.9189 10.6031 23.9136 10.5586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9414 10.8125C23.9487 10.887 23.9553 10.9617 23.9613 11.0366C23.9554 10.9617 23.9488 10.8869 23.9414 10.8125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 12.0913 23.9986 12.1822 23.9966 12.2729C23.9986 12.1821 24 12.0912 24 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9809 12.668C23.9774 12.7324 23.9732 12.7967 23.9688 12.8609C23.9732 12.7967 23.9773 12.7324 23.9809 12.668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9613 12.9648C23.9553 13.0397 23.9487 13.1144 23.9414 13.1889C23.9488 13.1144 23.9554 13.0397 23.9613 12.9648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9289 13.3086C23.9241 13.3532 23.919 13.3977 23.9136 13.4423C23.9189 13.3978 23.924 13.3532 23.9289 13.3086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9851 11.3984C23.9893 11.4843 23.9925 11.5705 23.995 11.6569C23.9925 11.5705 23.9894 11.4843 23.9851 11.3984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9947 12.3438C23.9923 12.4301 23.9891 12.5163 23.9849 12.6022C23.9892 12.5162 23.9923 12.4301 23.9947 12.3438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9888 11.4766H9.99401L2.80542 4.28906C2.57306 4.53412 2.3212 4.87631 2.16543 5.12001L9.04006 11.9983L2.15967 18.8788C2.29589 19.1211 2.59265 19.4798 2.80101 19.7132L9.99415 12.5201H23.9904C23.9979 12.347 24.0002 12.1732 24.0002 11.9983C24.0002 11.7641 23.9937 11.5913 23.9888 11.4766Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91515 14.5613V13.5562C3.91818 13.5562 4.73413 12.7401 4.73413 11.7372C4.73413 11.0276 4.15677 10.4503 3.44718 10.4503C2.96376 10.4503 2.57043 10.8435 2.57043 11.3271C2.57043 11.6362 2.82191 11.8877 3.1311 11.8877C3.30585 11.8877 3.44802 11.7455 3.44802 11.5707H4.45311C4.45311 12.2998 3.86005 12.8928 3.13115 12.8928C2.26776 12.8929 1.56543 12.1904 1.56543 11.3272C1.56543 10.2895 2.40965 9.44531 3.44722 9.44531C4.71106 9.44531 5.73931 10.4736 5.73931 11.7374C5.73927 13.2944 4.47238 14.5613 2.91515 14.5613Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4295_19716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaCountryCode);
export default __webpack_public_path__ + "static/media/SACountryCode.fa984c11732603d8919873e3f2d0890c.svg";
export { ForwardRef as ReactComponent };